<template>
  <div>
    <van-popup v-model="showPop" position="right" style="height: 100%; width: 80%" @click-overlay="closePopup">
      <div class="btn-wrap">
        <div class="pop-title">
          <p>搜索筛选区</p>
          <van-icon name="cross" @click="cancel"/>
        </div>
        <div class="select_list">
          <van-collapse v-model="activeNames" accordion>
            <van-collapse-item title="客户等级" name="1">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="custLevelIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in custLevelOptions" :key="item.custLevelId" @click="handleClick('custLevel',item.custLevelId,index)">{{ item.levelName }}</van-button>
            </van-collapse-item>
            <van-collapse-item title="客户来源" name="2">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="custSourceIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in custSourceOptions" :key="item.dictValue" @click="handleClick('custSource',item.dictValue,index)">{{ item.dictLabel }}</van-button>
            </van-collapse-item>
            <van-collapse-item title="客户类型" name="3">
              <van-button style="margin-right:5px;margin-bottom:5px;" :color="custTypeIndex === index ? 'blue' : ''" plain hairline size="small" v-for="(item,index) in custTypeOptions" :key="item.dictValue" @click="handleClick('custType',item.dictValue,index)">{{ item.dictLabel }}</van-button>
            </van-collapse-item>
          </van-collapse>
        </div>

      </div>
      <div class="input-wrap">
        <van-cell-group>
          <van-field v-model="queryParams.custName" label="客户名称" placeholder="请填写客户名称" />
          <van-field v-model="queryParams.industryName" label="行业名称" placeholder="请填写行业名称" />
        </van-cell-group>
      </div>
      <div class="footer-btn-wrap">
        <van-button size="mini" type="primary" class="resetBtn" @click="resetQuery">重置</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="submitForm">搜索</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="cancel">取消</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { selectAllCustLevel } from '@/api/scrm/custlevel'
import { Field, Popup, Icon, Button, Cell, CellGroup, CollapseItem, Divider, Collapse } from 'vant'
export default {
  name: 'SearchPop',
  props: ['show'],
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider
  },
  data() {
    return {
      activeNames: ['1'],
      showPop: false,
      custLevelIndex: null,
      custSourceIndex: null,
      custTypeIndex: null,
      queryParams: {},
      // 客户等级
      custLevelOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      // 客户类型
      custTypeOptions: this.$store.state.dictOptions.crmCustType || []
    }
  },
  watch: {
    show: function (newVal, oldVal) { // 不能用箭头函数
      this.showPop = newVal
    }
  },
  mounted() {
    this.getCustLevelList()
  },
  methods: {
    handleClick(type, prop, index) {
      switch (type) {
        case 'custLevel':
          this.queryParams.custLevelId = prop
          this.custLevelIndex = index
          break
        case 'custSource':
          this.queryParams.custSource = prop
          this.custSourceIndex = index
          break
        case 'custType':
          this.queryParams.custType = prop
          this.custTypeIndex = index
          break
        default:
          console.log('handleClick', type, prop)
      }
    },
    // 获取用户等级
    getCustLevelList() {
      selectAllCustLevel(null).then(response => {
        this.custLevelOptions = response.data
      })
    },
    resetQuery() {
      this.queryParams = {
        custLevelId: null,
        custName: null,
        custSource: null,
        custType: null,
        industryName: null
      }
      this.custLevelIndex = null
      this.custSourceIndex = null
      this.custTypeIndex = null
    },
    submitForm() {
      console.log(this.queryParams)
      this.$emit('handlequery', this.queryParams)
    },
    cancel() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    closePopup() {
      this.showPop = false
      this.$emit('update:show', false)
    }
  }
}
</script>
<style lang="less">
.btn-wrap {
  width: 100%;
  box-sizing: border-box;
  .close-icon {
    width: 20px;
    height: 20px;
  }
  .pop-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 0;
    padding: 0 30px;
  }
  .type-list {
    margin-bottom: 40px;
    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .list-wrapper {
      line-height: 0.5;
    }
  }
  .input-wrap {
    margin-top: 20px;
  }
  .select_list {
    .van-button {
      margin-top: 10px !important;
      margin-bottom: 10px !important;
    }
  }
}
.footer-btn-wrap {
  position: fixed;
  bottom: 100px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;

  display: flex;
  justify-content: space-around;

  .van-button {
    width: 45%;
    height: 60px;
    font-size: 30px;

    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
</style>
